export default __webpack_public_path__ + "static/media/pattern11.132c1493.png";